import { useState } from "react";
import { toast } from "sonner";
import { errMsg, formatDate, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";

const TONE = { PASS: "text-emerald-700", ATTENZIONE: "text-amber-700" };
const DECISIONS = [["", "Nessuna decisione"], ["continua", "Continua"], ["attenzione", "Continua con attenzione"], ["pausa", "Pausa"], ["rollback", "Rollback"]];
const fmt = (v) => (v && typeof v === "object" ? Object.entries(v).map(([k, x]) => `${k}: ${x ?? "—"}`).join(" · ") : String(v));

export function DiaryEntry({ e, onSaved }) {
  const api = useApi();
  const [notes, setNotes] = useState(e.notes || "");
  const [decision, setDecision] = useState(e.decision || "");
  const save = async () => {
    try { const { data } = await api.put(`/admin/pilot-diary/${e.date}`, { notes, decision: decision || null }); toast.success("Diario salvato"); onSaved(data); } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <section className="rounded-lg border border-slate-200 bg-white" data-testid={`diary-entry-${e.date}`}>
      <header className="flex flex-wrap items-center justify-between gap-2 border-b border-slate-100 px-4 py-3">
        <p className="font-medium text-slate-900">{e.date}</p>
        <p className="text-xs text-slate-500">Controlli {formatDate(e.snapshot_at, true)} da {e.snapshot_by}{e.updated_at ? ` · note ${formatDate(e.updated_at, true)}` : ""}</p>
      </header>
      <ul className="divide-y divide-slate-100">{e.checks.map((c) => (
        <li key={c.id} className="flex flex-wrap justify-between gap-2 px-4 py-2 text-sm" data-testid={`diary-${e.date}-check-${c.id}`}>
          <span className="text-slate-800">{c.label}</span>
          <span className="text-xs"><b className={`mr-2 ${TONE[c.status]}`}>{c.status}</b><span className="text-slate-500">{fmt(c.value)}</span></span>
        </li>))}</ul>
      <div className="space-y-2 border-t border-slate-100 p-4">
        <textarea value={notes} onChange={(x) => setNotes(x.target.value)} maxLength={2000} rows={3} placeholder="Note del referente (nessun dato personale dei clienti)"
          className="w-full rounded-md border border-slate-200 p-2 text-sm" data-testid={`diary-${e.date}-notes`} />
        <div className="flex flex-wrap items-center gap-2">
          <select value={decision} onChange={(x) => setDecision(x.target.value)} className="h-9 rounded-md border border-slate-200 bg-white px-2 text-sm" data-testid={`diary-${e.date}-decision`}>
            {DECISIONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <Button size="sm" onClick={save} data-testid={`diary-${e.date}-save`}>Salva</Button>
        </div>
      </div>
    </section>
  );
}
